import React, { useEffect, useMemo, useState } from "react";
import { cs, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

import {
  Card, CardContent, CardHeader, Typography, makeStyles
} from "@material-ui/core";
import { formatDistance } from "date-fns";

import { Currency, useExchangeRates, convertCurrency } from "@cargotic/currency";

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    backgroundColor: "#29AEA0",
    color: "#FFF",
    padding: spacing(1)
  },
  content: {
    "& > section": {
      display: "flex",
      justifyContent: "space-between"
    },
    marginBottom: 47,
    minHeight: 251
  }
}));

const useStyles2 = makeStyles(({ palette, spacing }) => ({
  root: {
    margin: 0,
    padding: spacing(1)
  }
}));

const ShipmentSummary = ({
  journey, values, outcomingOrder, apiClient
}) => {
  const { t } = useTranslation();
  const locale = t("locale") === "cs" ? cs : enUS;
  const {
    isLoading: isExchangeRatesLoading,
    exchangeRates
  } = useExchangeRates();

  const classes = useStyles();
  const classes2 = useStyles2();

  const [incomingOrders, setIncomingOrders] = useState(null);

  useEffect(() => {
    if (outcomingOrder) {
      const ids = outcomingOrder.incomingOrderIds
        || (outcomingOrder.incomingOrders && outcomingOrder.incomingOrders.map(({ id }) => id));

      if (ids) {
        Promise.all(
          ids.map(
            (incomingOrderId) => apiClient.incomingOrder.getIncomingOrderById({ incomingOrderId })
          )
        ).then(setIncomingOrders)
          .catch(() => setIncomingOrders(null));
        return;
      }
    }

    setIncomingOrders(null);
  }, [outcomingOrder.incomingOrders]);

  const priceValue = convertCurrency(parseInt(values.carrierPrice, 10), values.carrierPriceCurrency, "CZK", exchangeRates);
  const earningsValue = (incomingOrders || []).reduce((a, { customerPrice, customerPriceCurrency }) => a + convertCurrency(customerPrice, customerPriceCurrency, "CZK", exchangeRates), 0);

  const distance = (journey && journey.distance)
    ? `${(journey.distance / 1000).toFixed(2)} km`
    : t("webapp:outcomingOrder.summary.metric.unknown");

  const duration = (journey && journey.duration)
    ? formatDistance(new Date(journey.duration * 1000), new Date(0), { locale })
    : t("webapp:outcomingOrder.summary.metric.unknown");

  const earnings = earningsValue && values.carrierPriceCurrency
    ? `${earningsValue.toFixed(2)} CZK`
    : t("webapp:outcomingOrder.summary.metric.unknown");

  const price = priceValue && values.carrierPriceCurrency
    ? `${priceValue.toFixed(2)} CZK`
    : t("webapp:outcomingOrder.summary.metric.unknown");

  const commission = priceValue && earningsValue && values.carrierPriceCurrency
    ? `${(earningsValue - priceValue).toFixed(2)} CZK`
    : t("webapp:outcomingOrder.summary.metric.unknown");

  const metrics = [
    ["webapp:outcomingOrder.summary.label.distance", distance],
    ["webapp:outcomingOrder.summary.label.duration", duration],
    ["webapp:outcomingOrder.summary.label.earnings", earnings],
    ["webapp:outcomingOrder.summary.label.price", price],
    ["webapp:outcomingOrder.summary.label.commission", commission]
  ];

  return (
    <Card className={classes.root}>
      <CardHeader title={t("webapp:outcomingOrder.summary.title")} classes={classes2} />
      <CardContent className={classes.content}>
        {
          metrics.map(([label, value]) => (
            <section key={label}>
              <Typography>
                {t(label)}
              </Typography>
              <Typography>
                <b>
                  {value}
                </b>
              </Typography>
            </section>
          ))
        }
      </CardContent>
    </Card>
  );
};

export default ShipmentSummary;
